import { SearchInput } from 'framework/form';
import useExpertiseService from '../../service/expertiseService';
import { ListParams } from 'framework/list';
import { useCallback } from 'react';
import { Expertise, ExpertiseSearchRequestDto } from '../../service/expertiseService.types';

interface ExpertiseInputProps {
  source: string;
  errorSource?: string;
  label?: string;
  isRequired?: boolean;
  showLoader?: boolean;
  placeholder?: string;
}

const ExpertiseInput = ({ source, ...props }: ExpertiseInputProps) => {
  const { findExpertiseSuggestions } = useExpertiseService();

  const searchRequest = useCallback(
    ({ pageSize = 30, filter }: ListParams) => {
      const params: ExpertiseSearchRequestDto = {
        searchRequest: {
          pageNumber: 0,
          pageSize,
          filter: filter as ExpertiseSearchRequestDto['searchRequest']['filter'],
        },
      };
      return findExpertiseSuggestions(params);
    },
    [findExpertiseSuggestions],
  );

  const mapResults = ({ id, displayName }: Expertise) => ({
    id,
    text: displayName,
  });

  return (
    <SearchInput
      searchString="specification:expertiseDefinitionByNameOrAlias"
      nameSource="specification:expertiseDefinitionByNameOrAlias"
      searchRequest={searchRequest}
      noResultMessage="No expertise was found."
      source={source}
      mapResults={mapResults}
      {...props}
    />
  );
};

export default ExpertiseInput;
